// noinspection HtmlUnknownTarget

'use strict';

/**
 * Utility functions for arcano.app
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
*/


import {createPopper} from "@popperjs/core";
// import NoSleep from 'nosleep.js';
import {Placement} from "@popperjs/core/lib/enums";
import {gModal, ModalButton} from "./gmodal";
// @ts-ignore
import * as bootstrap from 'bootstrap';
import {translate} from "./translations";

// import {Modal} from "bootstrap";

/**
 * Delay user input on input
 */
export function delay(fn: (e: Event) => void, ms: number): any {
    let timer: any = null;
    return function(...args: any[]) {
        clearTimeout(timer)
        // @ts-ignore
        timer = setTimeout(fn.bind(this, ...args), ms || 0)
    }
}

/**
 * Overrides fetch and check if is real or plugin mode
 */
export function mfetch(url: string, options?: any): Promise<Response> {
    let path = url;
    if (options === undefined) {
        options = {};
    }
    if (document.location.href.indexOf('taskpane') >= 0) {
        // path = 'http://localhost:8008' + path;
        options.mode = 'cors';
    }
    return fetch(path, options)
}


/**
 * Shows a simple flash on top of the site
 */
export function showFlash(message: string, type: string, id?: string) {

    const flashDiv = document.createElement("div");
    flashDiv.setAttribute("role", "alert");
    flashDiv.className = "alert alert-" + type + " alert-dismissible fade out show";
    flashDiv.innerHTML = '<span>' + message + '</span><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>';

    const container = document.getElementById('alert-container')
    if (container) {
        if (id) {
            flashDiv.id = id;
            let child = container.querySelector(`#${id}`)
            if (child) {
                return
            }
        }
        container.append(flashDiv)
    }
}

// export function setupCookieBanner() {
//
//     if (document.location.hostname.indexOf('localhost') >= 0) {
//         return
//     }
//     if (document.location.hostname.indexOf('dev.arcano.app') >= 0) {
//         return
//     }
//     if (document.location.hostname.indexOf('stage.arcano.app') >= 0) {
//         return
//     }
//
//     const cookieTrue = 'true'
//     const cookieFalse = 'false'
//     const cookieValue = readCookie('analytics');
//     if(cookieValue === cookieFalse) {
//         return  // do nothing
//     }
//
//     if((document.location.href.indexOf('/external_upload') >= 0 ||
//         document.location.href.indexOf('/external_download') >= 0 ||
//         document.location.href.indexOf('/plugin') >= 0 ||
//         document.location.href.indexOf('/upload') >= 0 ||
//         document.location.href.indexOf('/widget') >= 0)) { // not on external uplaod and not on widget
//         return
//     }
//
//     function enableAnalytics() {
//         if(window.location.hostname  !== 'arcano.app') {  // not on staging
//             return
//         }
//
//         (function (w, d, s, l, i) {
//             // @ts-ignore
//             w[l] = w[l] || [];
//             // @ts-ignore
//             w[l].push({
//                 'gtm.start':
//                     new Date().getTime(), event: 'gtm.js'
//             });
//             // noinspection NegatedConditionalExpressionJS
//             let f = d.getElementsByTagName(s)[0],
//                 j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
//             // @ts-ignore
//             j.async = true;
//             // @ts-ignore
//             j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
//             // @ts-ignore
//             f.parentNode.insertBefore(j, f);
//         })(window, document, 'script', 'dataLayer', 'GTM-WC283ZC');
//
//     }
//     if (cookieValue === '') {
//         let options = 'Settings'
//         let okButtonText = 'I agree'
//         // let title = `We are sorry to disturb you`
//         let message =  `
//             <div class="mb-4">
//                 This site uses cookies to improve your experience and to track user choices with Google Analytics.
//                 You can customise how cookies are used with the button below.
// <!--                By closing this window, you accept the use of cookies.-->
//             </div>
//             <div class="small mb-3">
//                 <a href="/en/privacy">Privacy Policy</a>
//                 </div>
// <!--            <button id="cookie-consent-options-button" class="btn-sm mt-2 btn btn-outline-info" type="button" data-toggle="collapse" data-target="#cookieConsentCollapse" aria-expanded="false" aria-controls="cookieConsentCollapse">-->
// <!--                Options-->
// <!--            </button>           -->
//
//             <div class="mt-4 collapse" id="cookieConsentCollapse">
//                 <div class="">
//                     <div class="d-flex">
//                         Basic features <input class="ms-auto" type="checkbox" disabled checked id="cookies-consent-basic">
//                     </div>
//                     <div class="small muted">
//                         These cookies or other identifiers are used for activities that are necessary to ensure that our site works properly or to provide the services you have requested from us and, therefore, do not require your consent.
//                     </div>
//                     <div class="d-flex mt-3">
//                         Google Analytics <input class="ms-auto" type="checkbox" checked id="cookies-consent-google">
//                     </div>
//                     <div class="small muted">
//                         These cookies or other identifiers enable us to measure traffic and analyse your actions on our site with a view to improving our services.
//                     </div>
//                 </div>
//             </div>`
//
//         if (window.location.pathname.includes('/de/')) {
//             // title = `Entschuldigen Sie die Störung`
//             options = 'Einstellungen'
//             okButtonText = 'Einverstanden'
//             message =  `
//                 <div class="mb-4">
//                     Diese Website verwendet Cookies, um Ihre Erfahrung zu verbessern und um die Entscheidungen der Nutzer mit Google Analytics zu verfolgen.
//                     Sie können die Verwendung von Cookies über die Schaltfläche unten anpassen.
// <!--                    Wenn Sie dieses Fenster schließen, akzeptieren Sie die Verwendung von Cookies.-->
//                 </div>
//                 <div class="small mb-3">
//                     <a href="/de/privacy">Privacy Policy</a>
//                 </div>
// <!--                <button id="cookie-consent-options-button" class="btn-sm mt-2 btn btn-outline-info" type="button" data-toggle="collapse" data-target="#cookieConsentCollapse" aria-expanded="false" aria-controls="cookieConsentCollapse">-->
// <!--                    Einstellungen-->
// <!--                </button>           -->
//
//                 <div class="mt-4 collapse" id="cookieConsentCollapse">
//                     <div class="">
//                         <div class="d-flex">
//                             Grundlegende Funktionen <input class="ms-auto" type="checkbox" disabled checked id="cookies-consent-basic">
//                         </div>
//                         <div class="small muted">
//                             Diese Cookies oder anderen Identifikatoren werden für Aktivitäten verwendet, die notwendig sind, um das ordnungsgemäße Funktionieren unserer Website zu gewährleisten oder die von Ihnen angeforderten Dienstleistungen zu erbringen, und bedürfen daher nicht Ihrer Zustimmung.
//                         </div>
//                         <div class="d-flex mt-3">
//                             Google Analytics <input class="ms-auto" type="checkbox" checked id="cookies-consent-google">
//                         </div>
//                         <div class="small muted">
//                             Diese Cookies oder andere Identifikatoren ermöglichen es uns, den Datenverkehr zu messen und Ihre Aktivitäten auf unserer Website zu analysieren, um unsere Dienstleistungen zu verbessern.
//                         </div>
//                     </div>
//                 </div>`
//
//
//         }
//         if (window.location.pathname.includes('/fr/')) {
//
//             // title = `Désolé pour le dérangement`
//             options = 'Paramètres'
//             okButtonText = 'Je suis d\'accord'
//             message = `
//                 <div class="mb-4">
//                     Ce site utilise des cookies pour améliorer votre expérience et pour suivre les choix des utilisateurs avec Google Analytics.
//                     Vous pouvez personnaliser la façon dont les cookies sont utilisés avec le bouton ci-dessous.
// <!--                    En fermant cette fenêtre, vous acceptez l'utilisation des cookies.-->
//                 </div>
//                 <div class="small mb-3">
//                     <a href="/fr/privacy">Privacy Policy</a>
//                 </div>
//
// <!--                <button id="cookie-consent-options-button" class="btn-sm mt-2 btn btn-outline-info" type="button" data-toggle="collapse" data-target="#cookieConsentCollapse" aria-expanded="false" aria-controls="cookieConsentCollapse">-->
// <!--                    Options-->
// <!--                </button>           -->
//
//                 <div class="mt-4 collapse" id="cookieConsentCollapse">
//                     <div class="">
//                         <div class="d-flex">
//                             Caractéristiques de base <input class="ms-auto" type="checkbox" disabled checked id="cookies-consent-basic">.
//                         </div>
//                         <div class="small muted">
//                             Ces cookies ou autres identifiants sont utilisés pour des activités qui sont nécessaires pour assurer le bon fonctionnement de notre site ou pour fournir les services que vous nous avez demandés et, par conséquent, ne nécessitent pas votre consentement.
//                         </div>
//                         <div class="d-flex mt-3">
//                             Google Analytics <input class="ms-auto" type="checkbox" checked id="cookies-consent-google">.
//                         </div>
//                         <div class="small muted">
//                             Ces cookies ou autres identifiants nous permettent de mesurer le trafic et d'analyser vos actions sur notre site en vue d'améliorer nos services.
//                         </div>
//                     </div>
//                 </div>`
//
//         }
//     //     const showCookiesConsent = () => {
//     //         const cookieBackdrop = createElemWithClasses('div', ['cookie-consent-backdrop'])
//     //         const cookieConsent = createElemWithClasses('div', ['cookie-consent'])
//     //         const cookieConsentTitle = createElemWithClasses('div', ['cookie-consent-title'])
//     //         const cookieConsentMessage = createElemWithClasses('div', ['cookie-consent-message'])
//     //         const cookieConsentButtons = createElemWithClasses('div', ['cookie-consent-buttons', 'd-flex'])
//     //         const cookieConsentAccept = createElemWithClasses('button', ['ms-auto', 'btn', 'btn-primary', 'cookie-consent-accept'])
//     //         const cookieConsentSettings = createElemWithClasses('button', ['btn', 'btn-outline-info', 'cookie-consent-settings'])
//     //         cookieConsentAccept.innerText = okButtonText;
//     //
//     //         cookieConsentSettings.innerText = options;
//     //         cookieConsentSettings.dataset.bsToggle = 'collapse'
//     //         cookieConsentSettings.dataset.bsTarget = '#cookieConsentCollapse'
//     //
//     //         // data-toggle="collapse" data-target="#cookieConsentCollapse" aria-expanded="false" aria-controls="cookieConsentCollapse
//     //         cookieConsentAccept.addEventListener('click', () => {
//     //
//     //             const consent = document.getElementById('cookies-consent-google') as HTMLInputElement
//     //             const sayYesToGoogle = consent && consent.checked;
//     //             document.cookie = `analytics=${sayYesToGoogle ? cookieTrue : cookieFalse}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`
//     //             if(sayYesToGoogle) {
//     //                 enableAnalytics()
//     //             }
//     //             document.body.removeChild(cookieBackdrop)
//     //         })
//     //         cookieConsentButtons.append(cookieConsentSettings)
//     //         cookieConsentButtons.append(cookieConsentAccept)
//     //         // cookieConsentTitle.innerText = title
//     //         cookieConsentMessage.innerHTML = message;  // note: save innerHtml
//     //         cookieConsent.append(cookieConsentTitle);
//     //         cookieConsent.append(cookieConsentMessage);
//     //         cookieConsent.append(cookieConsentButtons);
//     //         cookieBackdrop.append(cookieConsent)
//     //         document.body.appendChild(cookieBackdrop)
//     //         cookieConsentAccept.focus()
//     //     }
//     //     showCookiesConsent()
//     // }
//     // if(cookieValue === cookieTrue) {
//     //     enableAnalytics()
//     // }
// }
//
export function upgradePrompt(upgradeLink: string, message: string, title: string) {

    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: "Upgrade",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    window.location.href = upgradeLink;
                }
            }
        ],
        close: {
            closable: false
        }
    }).show();
    // bootbox.alert({
    //     title: title,
    //     message: message,
    //     show: true,
    //     closeButton: false,
    //     buttons: {
    //         ok : {
    //             label: 'Upgrade',
    //             className: 'btn btn-info',
    //
    //         }
    //     },
    //     callback: function() {
    //         window.location.href = upgradeLink;
    //     }
    // })
}

/**
 *  The file is already expired
 */
export function fileIsExpiredPrompt() {
    let message = 'The file is expired or the download limit has been reached'
    let title = 'File expired'
    if (window.location.pathname.includes('/de/')) {
        title = 'Datei abgelaufen'
        message = 'Die Datei ist abgelaufen oder das Download-Limit wurde erreicht'
    }
    if (window.location.pathname.includes('/fr/')) {
        title = 'Le fichier est expiré'
        message = 'Le fichier est expiré ou la limite de téléchargement a été atteinte'
    }


    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: "Accept",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    modal.hide();
                }
            }
        ],
    }).show();





     // bootbox.alert({
     //     message: message,
     //     locale: locale,
     //     buttons: {
     //         ok: {
     //             className: 'btn-info',
     //         },
     //     }
     // })
}



/**
 *
 */
export function resharePrompt(callback: { (result: boolean): any }, options: any) {
    let title = translate('Share with contact')
    let noUserMessage = translate('You do not have any contacts yet. Add a contact in the sidebar to start sharing files.');

    let message;
    let buttons: Array<ModalButton>;
    if(options) {
        message = `<form id='reshare-infos' action=''>
                    <select class='form-control' id='reshare-contact'>
                        ${options}
                    </select>
                   </form>`
        buttons = [
            {
                content: "Cancel",
                classes: "btn btn-info-outline ms-auto",
                bindKey: 'Enter',
                callback: function (modal) {
                    // callback(false);
                    modal.hide();
                }
            },
            {
                content: "OK",
                classes: "btn btn-info ms-2 bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    callback(true);
                    modal.hide();
                }
            },

        ]
    } else {
        message = noUserMessage;
        buttons = [
            {
                content: "OK",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    modal.hide();
                }
            }
        ]
    }

    new gModal({
        title: title,
        body: message,
        buttons: buttons,
    }).show();



    // bootbox.confirm({
    //     title: title,
    //     message: `<form id='reshare-infos' action=''>
    //     <select class='form-control' id='reshare-contact'>
    //         ${options}
    //     </select>
    //     </form>`,
    //     locale: locale,
    //     buttons: {
    //         confirm: {
    //             className: 'btn-info',
    //         },
    //         cancel: {
    //             className: 'btn-outline-info'
    //         }
    //     },
    //     callback: callback
    // })
}
/**
 *  The file is already expired
 */
export function showDuplicateFileAlert(filename?: string) {
    let message = 'You cannot add two files with the same filename'
    if (window.location.pathname.includes('/de/')) {
        message = 'Sie können nicht zwei Dateien mit demselben Dateinamen hinzufügen'
    }
    if (window.location.pathname.includes('/fr/')) {
        message = 'Vous ne pouvez pas ajouter deux fichiers avec le même nom de fichier'
    }
    if (filename) {
        message += ': ' + filename;
    }

    const mymodal = new gModal({
        body: message,
        buttons: [
            {
                content: "OK",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    // console.log("You just accepted the Alert Modal");
                    modal.hide();
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                // console.log("You just closed the Alert Modal");
                modal.hide();
            }
        }
    });
    mymodal.show()



    // bootbox.alert({
    //     message: message,
    //     locale: locale,
    //     buttons: {
    //         ok: {
    //             className: 'btn-info',
    //         },
    //     }
    // })
}
/**
 *  Shows Referral link/code
 */
export function showReferral() {
    let title = "Refer Arcano to a colleague or friend!";
    let senderUid = document.getElementById("sender-uid")!;
    let code = senderUid.getAttribute("value");
    let link = window.location.origin + "/register_user?ref=" + code;
    let mailSubject = encodeURIComponent("Invitation to Arcano");
    let mailBody = encodeURIComponent("Hi, I want to invite you to use Arcano for your secure file-transfer needs. Join now using this link and we both get 10% off our subscription: " + link);
    let message2 = "Use the link below to refer. You will both get a 10% discount on your subscription.";
    let message3 = "You can also have your colleague or friend use this code on checkout";

    if (window.location.pathname.includes("/de/")) {
        title = "Empfehlen Sie Arcano einem Freund oder Kollegen!";
        mailSubject = encodeURIComponent("Einladung zu Arcano");
        mailBody = encodeURIComponent("Guten Tag, Ich möchte Sie dazu einladen Arcano für Ihre vertrauliche Dateiversendungen zu nutzen. Registrieren Sie sich jetzt über diesen Link und wir bekommen beide einen 10% Rabatt auf unser Abonnement.: "+ link);
        message2 = "Benutzen Sie diesen Link um jemanden Einzuladen. Sie erhalten beide 10% Rabatt auf Ihr Abonnement.";
        message3 = "Sie können auch diesen Code versenden. Ihr Kontakt kann diesen beim Abschluss eines Abonnements einlösen.";
    }
    if (window.location.pathname.includes("/fr/")) {
        title = "Recommandez Arcano à un ami ou à un collègue!";
        mailSubject = encodeURIComponent("Invitation à Arcano");
        mailBody = encodeURIComponent("Bonjour, j'aimerais vous inviter à utiliser Arcano pour vos besoins en matière de transfert sécurisé de fichiers. Inscrivez-vous maintenant en utilisant ce lien et nous bénéficierons tous les deux d'une remise de 10 % sur notre abonnement :" + link);
        message2 = "Utilisez le lien ci-dessous pour me recommander. Vous bénéficierez tous deux d'une réduction de 10 % sur votre abonnement.";
        message3 = "Vous pouvez également demander à votre collègue ou ami d'utiliser ce code lors du paiement.";
    }
    let message = `
        <div>
             ${message2}
        </div>
        <span class="input-group my-4">
            <input readonly class="form-control input-group-text bg-white" type="text" id='refLink' autofocus="" value="${link}">
            <span class="input-group-append btn-group btn-group">
                <button class="btn btn-outline-info" id="refLinkCopyButton"><img src="/img/icons/outline/copy.svg" alt="E-mail Link">Copy</button>
                <a id="ref-link-mailer" class="btn btn-outline-info" href="mailto:?subject=${mailSubject}&body=${mailBody}"><img src="/img/icons/outline/at-email.svg" alt="Email"> E-mail</a>
            </span>
           </span>
        <label>
           ${message3}:
       </label>
       <div class="text-center fw-bold">${code}</div>`;


    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: "OK",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    modal.hide();
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();

    // bootbox.alert({
    //   title,
    //   message,
    //   locale,
    //   buttons: {
    //     ok: {
    //       className: "btn-info"
    //     }
    //   }
    // });




    return link;
}


/**
 *  Handles Goodie
 */
export function showGoodie() {

    let title = translate('Onetime free transfer bonus.');
    let message2 = translate("Thank you for using Arcano! You have reached your 3 free transfers this month, this one time the next 5 are a little thank-you gift from us.");
    let message3 = translate("Get 5 free transfers now");

    let message = `<div>
                        ${message2}
                        <br>
                        <div class="text-center">
                            <img src="/img/gift.svg" alt="Reward" width="200" height="200">
                        </div>
                   </div>`;



    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: message3,
                classes: "btn btn-info ms-auto bootbox-accept w-100",
                bindKey: 'Enter',
                callback: function () {

                    mfetch("/goodie").then(r => {
                        if(r.status === 200) {
                            console.log('Hurray')
                        }
                    }).finally(() => {
                        window.location.reload()
                    })
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();




}

/**
 *  The file is already expired
 */
export function showDownloadFailedPrompt() {
    let message = 'The download of this file failed'
    // let locale = 'en';
    if (window.location.pathname.includes('/de/')) {
        // locale = 'de';
        message = 'Der Download dieser Datei ist fehlgeschlagen'
    }
    if (window.location.pathname.includes('/fr/')) {
        // locale = 'fr';
        message = 'Le téléchargement de ce fichier a échoué'
    }

    new gModal({
        body: message,
        buttons: [
            {
                content: "OK",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    modal.hide();
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();
     // bootbox.alert({
     //     message: message,
     //     locale: locale,
     //     buttons: {
     //         ok: {
     //             className: 'btn-info',
     //         },
     //     }
     // })
}
/**
 * Shows the wrong password prompt
 */
export function showPasswordErrorPrompt(callback?: () => void) {
    let message = 'Wrong Password'
    if (window.location.pathname.includes('/de/')) {
        message = 'Passwort Falsch'
    }
    if (window.location.pathname.includes('/fr/')) {
        message = 'Mot de passe invalid'
    }


    new gModal({
        body: message,
        buttons: [
            {
                content: "OK",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    modal.hide();
                }
            }
        ],
    }).show();




     // bootbox.alert({
     //     message: message,
     //     locale: locale,
     //
     //     buttons: {
     //         ok: {
     //             className: 'btn-info',
     //         },
     //     },
     //     callback: callback
     // })
}


export function hideAllBootboxes() {
    // bootbox.hideAll()
    // todo:
}
/**
 * Shows the wrong password prompt
 */
export function showReencryptFilesPrompt() {
    let title = 'Please wait while we re-encrypt your data.'
    if (window.location.pathname.includes('/de/')) {
        title = 'Bitte warten Sie, während wir Ihre Daten neu verschlüsseln.'
    }
    if (window.location.pathname.includes('/fr/')) {
        title = 'Veuillez patienter pendant que nous re-cryptons vos données.'
    }
    let message = `
     <div class="progress">
         <div id="re-encrypt-progress" class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
     </div>`;

    const modal = new gModal({
        title: title,
        body: message,
        close: {
            closable: false
        }
    });
    modal.show();
    return modal;

//      return bootbox.dialog({
//          title: title,
//          message: `
//              <div class="progress">
//                  <div id="re-encrypt-progress" class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
//              </div>
// `        ,
//          locale: locale,
//          onEscape: false,
//          // backdrop: false,
//          closeButton: false,
//      })
}

/**
 * Show the wrong PIN prompt
 */
export function showPinErrorPrompt() {
    let message = 'Wrong PIN'
    if (window.location.pathname.includes('/de/')) {
        message = 'PIN Falsch'
    }
    if (window.location.pathname.includes('/fr/')) {
        message = 'Code PIN invalid'
    }

    new gModal({
        title: message,
        buttons: [
            {
                content: "OK",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    modal.hide();
                }
            }
        ],
    }).show();


     // bootbox.alert({
     //     message: message,
     //     locale: locale,
     //
     //
     //     buttons: {
     //         ok: {
     //             className: 'btn-info',
     //         },
     //     }
     // })
}


/**
 * Tell the user to subscribe
 */
export function showFreeTierDepletedPrompt() {

    if(document.getElementById('free-tier-prompt')) {
        return; // do not call this mnay times
    }

    let message = '<p id="free-tier-prompt"><strong>Please upgrade for unlimited transfers.</strong></p><p>You have reached the limits of your free account.</p><p class="small text-muted">Your limits will be reset the first of each month. Or <a href="/en/contact_us">contact us</a> for more free transfers.</p>';
    if (window.location.pathname.includes('/de/')) {
        message = '<p><strong>Für unlimitierte Übertragungen upgraden Sie bitte Ihren Account.</strong></p><p>Sie haben die Limiten Ihres kostenlosen Kontos erreicht.</p><p class="small text-muted">Ihre Limits werden am Ersten eines jeden Monats zurückgesetzt. Oder <a href="/de/contact_us">kontaktieren Sie uns</a> für weitere kostenlose Transfers.</p>'
    }
    if (window.location.pathname.includes('/fr/')) {
        message = '<p><strong>Pour des transferts illimités, veuillez mettre à jour votre compte.</strong></p><p>Vous avez atteint les limites de votre compte gratuit.</p><p class="small text-muted">Vos limites seront remises à zéro le premier de chaque mois. Ou <a href="/fr/contact_us">contactez-nous</a> pour plus des transferts gratuits.</p>'
    }

    new gModal({

        body: message,
        buttons: [
            {
                content: "Upgrade",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    upgradeSubscription(true);
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();

    // bootbox.confirm({
     //     message: message,
     //     locale: locale,
     //
     //     buttons: {
     //         confirm: {
     //             label: label,
     //             className: 'btn-info',
     //         },
     //         cancel: {
     //             className: 'btn-outline-info'
     //         }
     //     },
     //     callback: upgradeSubscription
     // })
}



export function upgradeSubscription(result: boolean) {
    if(result) {
        if (window.location.pathname.includes('/de/')) {
            window.location.href = '/de/payments'
        }
        if (window.location.pathname.includes('/fr/')) {
            window.location.href = '/fr/payments'
        }
        window.location.href = '/en/payments'
    }
}

export function freeTier(addedFileSize?: number, files?: Array<File>): Boolean {
    // todo will need to revoke
    // const uploadCount = document.getElementById('upload_count') as HTMLInputElement
    // const transferVolume = document.getElementById('transfer_volume') as HTMLInputElement
    // const storageVolume = document.getElementById('storage_volume') as HTMLInputElement
    // if(uploadCount && transferVolume) {
    //     let transferLimitExceeded = parseInt(uploadCount.value) >= 10;
    //     if(!addedFileSize) {
    //         addedFileSize = 0;
    //     }
    //
    //     let numFiles = 0;
    //     if(files) {
    //         numFiles = Object.keys(files).length
    //     }
    //
    //     let numFilesExceeded = numFiles >= 10000;
    //
    //     let transferVolumeExceeded = (parseFloat(transferVolume.value) + addedFileSize) > 1024 * 1024 * 1024 * 50;
    //
    //     if (transferLimitExceeded || transferVolumeExceeded || numFilesExceeded) {
    //         return false;
    //     }
    // }
    return true;
}

/**
 * Shows the message in a modal
 */
export function messagePrompt(message: string) {

    let title = "The sender left you a message";
    if (window.location.pathname.includes('/de/')) {
        title = 'Der Absender hat Ihnen eine Nachricht hinterlassen'
    }
    if (window.location.pathname.includes('/fr/')) {
        title = 'L\'expéditeur vous a laissé un message'
    }

    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: "OK",
                classes: "btn btn-info ms-auto bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    modal.hide();
                }
            }
        ],
    }).show();

    // bootbox.alert({
    //     title: title,
    //     message: message,
    //     locale: locale,
    //     onEscape: true,
    //     backdrop: true
    // })
}
/**
 * Shows the confirmation modal for deleting files
 */
export function deleteFilesPrompt(cb: (res: boolean) => any) {
    let title = "Are you sure you want to delete the selected files?";
    let message = "This will also remove access to everybody you shared the file with";
    if (window.location.pathname.includes('/de/')) {
        title = 'Sind Sie sicher, dass Sie die ausgewählten Dateien löschen möchten?'
        message = 'Dadurch wird auch der Zugriff auf alle Personen, mit denen Sie die Datei geteilt haben, aufgehoben';
    }
    if (window.location.pathname.includes('/fr/')) {
        title = 'Êtes-vous sûr de vouloir supprimer les fichiers sélectionnés ?'
        message = 'Cela supprimera également l\'accès à toutes les personnes avec lesquelles vous avez partagé le dossier';
    }


    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: "Cancel",
                classes: "btn btn-outline-info ms-auto",
                bindKey: 'Escape',
                callback: function (modal) {
                    modal.hide();
                }
            },
            {
                content: "Delete",
                classes: "btn btn-danger ms-2 bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    cb(true)
                    modal.hide();
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();

    // bootbox.confirm({
    //     title: title,
    //     message: message,
    //     locale: locale,
    //     buttons: {
    //         confirm: {
    //             className: 'btn-danger',
    //         },
    //         cancel: {
    //             className: 'btn-outline-info'
    //         }
    //     },
    //     callback: cb
    // })
}


/**
 * Shows the archive  files modal
 */
export function archiveFilesPrompt(cb: (res: boolean) => any){
    let title = "Are you sure you want to move the selected files to your Archive?";
    let message = "This will also remove access to everybody you shared the file with";
    if (window.location.pathname.includes('/de/')) {
        title = 'Sind Sie sicher, dass Sie die ausgewählten Dateien in Ihr Archiv verschieben möchten?'
        message = 'Dadurch wird auch der Zugriff auf alle Personen, mit denen Sie die Datei geteilt haben, aufgehoben';
    }
    if (window.location.pathname.includes('/fr/')) {
        title = 'Êtes-vous sûr de vouloir déplacer les fichiers sélectionnés vers vos archives ?'
        message = 'Cela supprimera également l\'accès à toutes les personnes avec lesquelles vous avez partagé le dossier';
    }

    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: "Cancel",
                classes: "btn btn-outline-info ms-auto",
                bindKey: 'Escape',
                callback: function (modal) {
                    modal.hide();
                }
            },
            {
                content: "OK",
                classes: "btn btn-info ms-2 bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    cb(true);
                    modal.hide();
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();

    // bootbox.confirm({
    //     title: title,
    //     message: message,
    //     locale: locale,
    //     buttons: {
    //         confirm: {
    //             className: 'btn-info',
    //         },
    //         cancel: {
    //             className: 'btn-outline-info'
    //         }
    //     },
    //     callback: cb
    // })
}


/**
 * Store decryption key in indexeddb, we cannot use local or session storage, because there one can only
 * store extractable keys. The key in IndexedDb can be set to onn extractable, so this is safer
 */
export function setItem(db: IDBDatabase,
                        key: string,
                        value: any,
                        oncomplete: (e: Event) => any,
                        onerror: (e: Event) => any)
{
    let tx = db.transaction(['key'], 'readwrite');
    let store = tx.objectStore('key');
    store.put(value, key);
    // Wait for the database transaction to complete
    tx.oncomplete = oncomplete;
    tx.onerror = onerror;
}


/**
 * Deletes a key from the indexeddb
 */
export function deleteItem(db: IDBDatabase,
                           key: string,
                           oncomplete: (e: Event) => any,
                           onerror: (e: Event) => any)
{
    let tx = db.transaction(['key'], 'readwrite');
    let store = tx.objectStore('key');
    let req = store.delete(key);
    req.onsuccess = oncomplete;
    req.onerror = onerror;
}

/**
 * Returns the decryptiopn key from indexeddb
 */
export function getItem(db: IDBDatabase,
                        key: string,
                        oncomplete: (e: Event) => any,
                        onerror: (e: Event) => any)
{
    let tx = db.transaction(['key'], 'readwrite');
    let store = tx.objectStore('key');
    let req = store.get(key);
    // We can use the note if the request succeeds, getting it in the
    // onsuccess handler
    req.onsuccess = oncomplete;
    // If we get an error, like that the note wasn't in the object
    // store, we handle the error in the onerror handler
    req.onerror = onerror;
}


/**
 * Shows the prompt modal for password
 */
export function passwordPrompt(cb: (res: string) => any) {
    let title = 'Please enter your password'
    let inputId = Math.random().toString(36).substr(2);

    if (window.location.pathname.includes('/de/')) {
        title = 'Bitte geben Sie Ihr Passwort ein'

    }
    if (window.location.pathname.includes('/fr/')) {
        title = 'Veuillez entrer votre mot de passe'

    }
    let message = `<input type="password" id="${inputId}" class="form-control" placeholder="Password" required>`;

    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: "Cancel",
                classes: "btn btn-outline-info ms-auto",
                bindKey: 'Escape',
                callback: function (modal) {
                    modal.hide();
                }
            },
            {
                content: "OK",
                classes: "btn btn-info ms-2",
                bindKey: 'Enter',
                callback: function (modal) {
                    const input = document.getElementById(inputId) as HTMLInputElement;
                    let password = '';
                    if(input && input.value) {
                        password = input.value;
                    }
                    cb(password);
                    modal.hide();
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();


    // bootbox.prompt({
    //     title: title,
    //     locale: locale,
    //     inputType: 'password',
    //     buttons: {
    //         confirm: {
    //             className: 'btn-info',
    //         },
    //         cancel: {
    //             className: 'btn-outline-info'
    //         }
    //     },
    //     callback: cb
    // });
}

/**
 * Shows the prompt modal for PIN
 */
export function pinPrompt(cb: (res: string) => any) {
    let title = 'Please enter your PIN'
    let wrongPin = 'Wrong PIN'
    let inputId = Math.random().toString(36).substr(2);
    let message = "This PIN should have been communicated to you by the sender. Without the PIN you can not decrypt these files";
    if (window.location.pathname.includes('/de/')) {
        title = 'Bitte geben Sie Ihre PIN ein'
        message = "Der PIN sollte Ihnen vom Sender mitgeteilt worden sein. Ohne diesen PIN können Sie diese Dateien nicht entschlüsseln.";
        wrongPin = 'PIN Falsch'
    }
    if (window.location.pathname.includes('/fr/')) {
        title = 'Veuillez entrer votre code PIN'
        message = "Ce code PIN doit vous avoir été communiqué par l'expéditeur. Sans ce code PIN, vous ne pouvez pas décrypter ces fichiers";
        wrongPin = 'Code PIN invalid'
    }

    let htmlMessage = `
                       <input type="password" autocomplete="new-password" id="${inputId}" class="form-control bootbox-input bootbox-input-password" placeholder="PIN" required>
                       <div class="small">${message}</div>
                       <div id="wrong-pin">${wrongPin}</div>`


    new gModal({
        title: title,
        body: htmlMessage,
        buttons: [
            {
                content: "Cancel",
                classes: "btn btn-outline-info ms-auto bootbox-cancel",
                bindKey: 'Escape',
                callback: function (modal) {
                    modal.hide();
                }
            },
            {
                content: "OK",
                classes: "btn btn-info ms-2 bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {

                    const input = document.getElementById(inputId) as HTMLInputElement;
                    let pin = '';
                    if(input && input.value) {
                        pin = input.value;
                    }
                    cb(pin);
                    modal.hide();
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();

    // bootbox.prompt({
    //     title: title,
    //     message: htmlMessage,
    //     locale: locale,
    //     inputType: 'password',
    //     buttons: {
    //         confirm: {
    //             className: 'btn-info',
    //         },
    //         cancel: {
    //             className: 'btn-outline-info'
    //         }
    //     },
    //     callback: cb
    // } as BootboxPromptOptions);
}

/**
 * Shows the prompt modal for unverified transfer
 */
export function unverifiedDownloadPrompt(cb: (res: boolean) => any) {

    let title = 'This file is from an unverified Sender'
    let message = "Are you sure you want to download?";
    if (window.location.pathname.includes('/de/')) {
        title = 'Dieser Transfer kommt von einem unverifizierten Absender'
        message = "Sind Sie sicher, dass Sie die ausgewählten Dateien herunterladen möchten ?";
    }
    if (window.location.pathname.includes('/fr/')) {
        title = 'Ce transfert provient d\'un expéditeur non vérifié'
        message = "Êtes-vous sûr de vouloir supprimer les fichiers sélectionnés ?";
    }

    new gModal({
        title: title,
        body: message,
        buttons: [
            {
                content: "Cancel",
                classes: "btn btn-outline-info ms-auto",
                bindKey: 'Escape',
                callback: function (modal) {
                    modal.hide();
                }
            },
            {
                content: "OK",
                classes: "btn btn-warning ms-2 bootbox-accept",
                bindKey: 'Enter',
                callback: function (modal) {
                    cb(true);
                    modal.hide();
                }
            }
        ],
        close: {
            bindKey: 'Escape', /* Esc */
            callback: function (modal) {
                modal.hide();
            }
        }
    }).show();

    // bootbox.confirm({
    //     title: title,
    //     message: message,
    //     locale: locale,
    //     buttons: {
    //         confirm: {
    //             className: 'btn-warning'
    //         },
    //         cancel: {
    //             className: 'btn-outline-info'
    //         }
    //     },
    //     callback: cb
    // });
}


/**
 * update the file counter bubbles in the sidebar and the navbar
 */
export function updateFileCounters() {
    const toIgnore = ['/external_download']
    if(toIgnore.some((ext) => {return document.location.pathname.includes(ext)})) {
        return
    }

    const fileList = document.getElementById('filelist')
    const explorer = document.getElementById('transfer-file-list');

    if (!fileList && !explorer) {
        return
    }

    mfetch('/file/count', { "headers": {"cache-control": "no-cache"}})
        .then(response => {
            return response.json()
        })
        .then(data => {
            if (data) {
                let inbox = document.getElementById('inbox-count');
                if (inbox && data.hasOwnProperty('n')) {
                    inbox.innerText = data.n;
                    inbox.style.display = data.n > 0 ? 'inline-block' : 'none'
                }
            }
        }).catch(() => {
            console.debug('Could not update file counters')
    });
}


export function setupPasswordEye() {

    const passwordEye = document.getElementById('show-password');

    if(passwordEye) {
        passwordEye.addEventListener('click', (event) => {
            event.preventDefault();

            let pswd_input = document.querySelector('#password');
            if (pswd_input) {
                const pswd_input_type = pswd_input.getAttribute('type') === 'password' ? 'text' : 'password';
                pswd_input.setAttribute('type', pswd_input_type);
            }
            // let pswd_eye_icon = document.getElementById('pswd-eye-icon');
            // if (pswd_eye_icon) {
            //     // alternate between eye and eye-slash
            //     if (pswd_eye_icon.className.includes("slash")) {
            //         pswd_eye_icon.className = "fas fa-eye"
            //     } else {
            //         pswd_eye_icon.className = "fas fa-eye-slash"
            //     }
            // }
        });
    }
}


export function checkNewFiles() {
    const toIgnore = ['/external_download']
    if(toIgnore.some((ext) => {return document.location.pathname.includes(ext)})) {
        return
    }

    const fileList = document.getElementById('filelist')

    if (!fileList) {
        return
    }

    let start = new Date().getTime()

    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if(target.id === 'goto-inbox-button') {
            e.preventDefault();
            let receivedTabButton = document.getElementById('files-received')
            if(receivedTabButton) {
                receivedTabButton.click()
                target.closest('div')!.remove()
            }
        }
    })


    function update() {
        mfetch('/file/count', {"headers": {"cache-control": "no-cache"}})
            .then(response => response.json())
            .then(data => {
                if (data) {
                    let inbox = document.getElementById('inbox-count')!;
                    if (inbox && data.hasOwnProperty('n')) {
                        inbox.innerText = data.n;
                        inbox.style.display = 'inline-block';
                    }

                    if(data.hasOwnProperty('newest')) {

                        if(start < data.newest) {
                            inbox.classList.add('generic-pulse')
                            showFlash('<a id="goto-inbox-button">You received new files, click here to go to your inbox</a>', 'info', 'new-file-message')
                            start = data.newest;
                            setTimeout(() => {
                                inbox.classList.remove('generic-pulse')
                            }, 15000);
                        }
                    }
                }
            }).catch(() => {});
    }
    update()
    setInterval(update, 15000)
    // Notification.requestPermission().then(function (result) {

    // });
}


/**
 */
export function initUtils(db: IDBDatabase) {

    let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    });
    // if(typeof window.jQuery !== "undefined") {
    // $('[data-toggle="popover"]').popover({trigger: 'click hover'});
    // }

    setupMonthAnnualSwitch();

    setupNavLangLinks();
    // updateFileCounters();
    setupClipboardButtons()

    // detectSafari();
    setupLogoutClearDB(db);

}

/**
 * Clear stuff on logout
 */
function setupLogoutClearDB(db: IDBDatabase) {

    let logoutButton = document.getElementById('logout-button');
    if (logoutButton) {
        logoutButton.onclick = event => {
            event.preventDefault()

            const oncomplete = () => {
                if (window.location.pathname.includes('/de/')) {
                    window.location.href = '/de/logout';
                } else if (window.location.pathname.includes('/fr/')) {
                    window.location.href = '/fr/logout';
                } else {
                    window.location.href = '/logout';
                }
            }
            const onerror = () => {
                if (window.location.pathname.includes('/de/')) {
                    window.location.href = '/de/logout';
                } else if (window.location.pathname.includes('/fr/')) {
                    window.location.href = '/fr/logout';
                } else {
                    window.location.href = '/logout';
                }
            }
            if (db) {
                deleteItem(db, 'key', oncomplete, onerror);
            } else {
                window.location.href = '/logout';
            }
        }
    }
}

/**
 */
function setupNavLangLinks() {

    const deNavLink = document.getElementById('de-nav-link') as HTMLAnchorElement;
    const enNavLink = document.getElementById('en-nav-link') as HTMLAnchorElement;
    const frNavLink = document.getElementById('fr-nav-link') as HTMLAnchorElement;

    let locationPathname = document.location.pathname;
    if (locationPathname.startsWith('/de/') || locationPathname.startsWith('/en/') || locationPathname.startsWith('/fr/')) {
        locationPathname = locationPathname.substring(3);
    }

    if (deNavLink) {
        deNavLink.href = '/de' + locationPathname + document.location.search + document.location.hash;
        deNavLink.addEventListener('click', (e) => {
            e.preventDefault()
            setDefaultLanguage('de').then(() => {

            })
            .catch(()=>{})
            .finally(() => {
                document.location.href = deNavLink.href
            })
        })
    }

    if (enNavLink) {
        enNavLink.href = '/en' + locationPathname + document.location.search + document.location.hash;
        enNavLink.addEventListener('click', (e) => {
            e.preventDefault()
            setDefaultLanguage('en').then(() => {

            })
            .catch(()=>{})
            .finally(() => {
                document.location.href = enNavLink.href
            })
        })
    }

    if (frNavLink) {
        frNavLink.href = '/fr' + locationPathname + document.location.search + document.location.hash;
        frNavLink.addEventListener('click', (e) => {
            e.preventDefault()
            setDefaultLanguage('fr').then(() => {

            })
            .catch(()=>{})
            .finally(() => {
                document.location.href = frNavLink.href
            })
        })
    }
}

async function setDefaultLanguage(lang: string) {
    const data = new FormData()
    data.append('default_language', lang)
    return mfetch('/edit_default_language', {
        method: 'POST',
        body: data
    })
}

const onbeforeUnloadUploadDownload = (event: BeforeUnloadEvent) => {

    // Cancel the event as stated by the standard.
    event.preventDefault();
    // Older browsers supported custom message
    event.returnValue = '';

}

// let noSleep = new NoSleep();


export function enableWarningOnPageUnload() {
    console.log('adding unload listener')
    window.addEventListener('beforeunload', onbeforeUnloadUploadDownload)
    // noSleep.enable().then(() => {});
}


export function disableWarningOnPageUnload() {
    console.log('remove unload listener')
    window.removeEventListener('beforeunload', onbeforeUnloadUploadDownload)
    // noSleep.disable();
}


/**
 * Show the errors coming from the server to form inputs
 * For example for login.js / register.js and reset.js this must be done in the frontend
 * Because we do not want to know the password
 *
 */
export function showErrorsOnForm(response: any) {
    let errors: any;
    try {
        errors = JSON.parse(response);
    }
    catch (e) {
        errors = [[response]]
    }
    try {

        Object.keys(errors).forEach(function(key) {
            let value = errors[key]
            let id = 'errors-' + key

            const e = document.getElementById(id)
            if(e) {
                e.remove()
            }

            let elem = document.createElement('div')
            elem.className = 'errors'
            elem.id = id

            let sibling = document.getElementById(key)
            if(!sibling) {
                sibling = document.getElementById('username')
            }

            sibling!.parentElement!.appendChild(elem)
            for (let i=0;i < value.length; i++ ) {
                let er = document.createElement('div')
                er.innerText = value[i]
                elem.appendChild(er)
            }
        });
    } catch (e) {
        console.log(e)
    }
}
//
// /**
//  * Converts filesizes to human readable
//  */
// export function humanFilesize(num: number): string {
//     let precision = 1;
//     const units = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z']
//     for (let i = 0; i < units.length; i++) {
//         let unit = units[i];
//         if (Math.abs(num) < 1024.0) {
//             if (unit === '') {
//                 precision = 0
//             }
//             let bytes = num.toFixed(precision)
//             return `${bytes}${unit}B`
//         }
//         num /= 1024.0;
//     }
//     let bytes = num.toFixed(precision)
//     return `${bytes}YB`
// }

/**
 * If the browser does not support copy to clipboard, use this approach
 */
function fallbackCopyTextToClipboard(text: string) {
    // noinspection JSDeprecatedSymbols
    if (!document.queryCommandSupported || !document.queryCommandSupported("copy")) {
        console.error('Copy to clipboard is not supported');
        return;
    }

    let textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";  //avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        // noinspection JSDeprecatedSymbols
        let successful = document.execCommand('copy');
        let msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Unable to copy', err);
    } finally {
        document.body.removeChild(textArea);
    }
}


export function showTooltip(element: Element, error: string, placement: string, timeout?: number) {
    const tooltip = createElemWithClasses('div', ['popper-error-message'])
    tooltip.innerText = error;
    document.body.appendChild(tooltip)
    let message = createPopper(element, tooltip, {
        placement: placement as Placement,
    });
    if(timeout) {
        setInterval(() => {
            message.destroy();
            tooltip.remove()
        }, 5000)
    }
}

/**
 * Sets something into the clipboard
 */
export function copyTextToClipboard(text: string) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }

    navigator.clipboard.writeText(text).then(function () {
        console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
}

/**
 */
export function setupClipboardButtons() {

    // if(typeof jQuery !== "undefined") {
    //     $('#show-copy-modal-again-button').on('click', function () {
    //         $('#copyLinkModal').modal();
    //     })
    // }


    const clipperElements = [
        {button: 'download-link-clipper', target: 'secret-input'},
        {button: 'clipboardModalCopySecretButton', target: 'clipboardModalCopySecret'},
        {button: 'clipboardCopySecretButton', target: 'clipboardCopySecret'},
        {button: 'refLinkCopyButton', target: 'refLink'},
        {button: 'clipboardCopySecret', target: 'clipboardCopySecret'},
        {button: 'public-link-clipper', target: 'personalized-upload-link'},
        {button: 'personalized-upload-link', target: 'personalized-upload-link'},
        {button: 'public-link-clipper-2', target: 'personalized-upload-link-2'},
        {button: 'public-link-clipper-help', target: 'personalized-upload-link-help'},
        {button: 'personalized-upload-link-help', target: 'personalized-upload-link-help'},
        {button: 'download-link-clipper', target: 'secret-input'}
    ]

    for(let clipper of clipperElements) {
        const button = document.getElementById(clipper.button);
        if (button) {
            button.addEventListener('click', function () {
                let copyTargetElement, copyTargetText;
                copyTargetElement = document.getElementById(clipper.target) as HTMLInputElement;
                if (copyTargetElement) {
                    copyTargetElement.focus();
                    copyTargetElement.select();
                    copyTargetText = copyTargetElement.value;
                }

                if (copyTargetText) {
                    copyTextToClipboard(copyTargetText);
                    showTooltip(copyTargetElement, "Copied", "top", 5000)
                }
            });
        }
    }


    document.querySelectorAll('code').forEach(snippet => {
        snippet.addEventListener('click', (e) => {
            const text = snippet.innerText;
            copyTextToClipboard(text);
            showTooltip(snippet, "Copied", "top", 5000)

        })
    })

}

export function getUppyGermanLocale() {
    return {
        strings: {

            dropPasteFiles: 'Add files or %{browseFiles}',
            dropPasteFolders: '%{browseFiles}',
            dropPasteBoth: '%{browseFiles}%{browseFolders}',  // Drop files here,
            dropPasteImportFiles: 'ttttAdd files, %{browseFiles}:',
            dropPasteImportFolders: 'OOAdd files here or %{browseFolders} or upload from:',
            dropPasteImportBoth: '%{browseFiles} %{browseFolders}',
            dropHint: 'Drop your files here',
            browseFiles: 'Dateien auswählen',
            uploading: 'Encrypting and uploading',
            browseFolders: 'oder wählen Sie einen Ordner',
            addMoreFiles: 'Dateien hinzufügen',
            addingMoreFiles: 'Dateien hinzufügen',
            allowAccessDescription: 'Um Bilder oder Videos mit Ihrer Kamera aufzunehmen, erlauben Sie dieser Website bitte Zugriff auf Ihre Kamera.',
            allowAccessTitle: 'Bitte erlauben Sie Zugriff auf Ihre Kamera',
            authenticateWith: 'Mit %{pluginName} verbinden',
            authenticateWithTitle: 'Bitte authentifizieren Sie sich mit %{pluginName}, um Dateien auszuwählen',
            back: 'Zurück',
            addMore: 'Dateien hinzufügen',
            browse: 'Suche',
            // browseFiles: 'Suche',
            cancel: 'Abbrechen',
            cancelUpload: 'Upload abbrechen',
            chooseFiles: 'Dateien auswählen',
            closeModal: 'Modal schließen',
            companionError: 'Verbindung zu Companion fehlgeschlagen',
            complete: 'Fertig',
            connectedToInternet: 'Verbunden mit dem Internet',
            copyLink: 'Link kopieren',
            copyLinkToClipboardFallback: 'Untenstehenden URL kopieren',
            copyLinkToClipboardSuccess: 'Link in die Zwischenablage kopiert',
            creatingAssembly: 'Upload vorbereiten...',
            creatingAssemblyFailed: 'Transloadit: Konnte Assembly nicht erstellen',
            dashboardTitle: 'Datei Uploader',
            dashboardWindowTitle: 'Datei Uploader Fenster (Esc drücken zum Schließen)',
            dataUploadedOfTotal: '%{complete} von %{total}',
            done: 'Abgeschlossen',

            editFile: 'Datei bearbeiten',
            editing: '%{file} bearbeiten',
            emptyFolderAdded: 'Keine Dateien konnten hinzugefügt werden, da der Ordner leer war',
            encoding: 'Enkodieren...',
            enterCorrectUrl: 'Falsche URL: Bitte stellen Sie sicher, dass Sie einen direkten Link zu einer Datei eingeben',
            enterUrlToImport: 'URL zum Importieren einer Datei eingeben',
            exceedsSize: 'Diese Datei ist größer als die maximal erlaubte Dateigröße',
            failedToFetch: 'Companion konnte diese URL nicht verarbeiten - stellen Sie bitte sicher, dass sie korrekt ist',
            failedToUpload: 'Fehler beim Upload von Datei %{file}',
            fileSource: 'Dateiquelle: %{name}',
            filesUploadedOfTotal: {
                '0': '%{complete} von %{smart_count} Datei hochgeladen',
                '1': '%{complete} von %{smart_count} Dateien hochgeladen',
                '2': '%{complete} von %{smart_count} Dateien hochgeladen'
            },
            filter: 'Filter',
            finishEditingFile: 'Dateibearbeitung beenden',
            folderAdded: {
                '0': '%{smart_count} Datei von %{folder} hinzugefügt',
                '1': '%{smart_count} Dateien von %{folder} hinzugefügt',
                '2': '%{smart_count} Dateien von %{folder} hinzugefügt'
            },
            import: 'Import',
            importFrom: 'Importieren von %{name}',
            loading: 'Laden...',
            logOut: 'Ausloggen',
            myDevice: 'Meinem Computer',
            noCameraDescription: 'Bitte Kamera anschließen, um Bilder oder Videos aufzunehmen',
            noCameraTitle: 'Kamera nicht verfügbar',
            noDuplicates: 'Datei \'%{fileName}\' existiert bereits und kann nicht erneut hinzugefügt werden',
            noFilesFound: 'Sie haben keine Dateien oder Ordner hier',
            noInternetConnection: 'Keine Internetverbindung',
            noNewAlreadyUploading: 'Während der Upload läuft, können keine weiteren Dateien hinzugefügt werden',
            pause: 'Pausieren',
            pauseUpload: 'Upload pausieren',
            paused: 'Pausiert',
            poweredBy: 'Angetrieben von',
            processingXFiles: {
                '0': '%{smart_count} Datei verarbeiten',
                '1': '%{smart_count} Dateien verarbeiten',
                '2': '%{smart_count} Dateien verarbeiten'
            },
            recordingLength: 'Aufnahmedauer %{recording_length}',
            removeFile: 'Datei entfernen',
            resetFilter: 'Filter zurücksetzen',
            resume: 'Fortsetzen',
            resumeUpload: 'Upload fortsetzen',
            retry: 'Erneut versuchen',
            retryUpload: 'Upload erneut versuchen',
            saveChanges: 'Änderungen speichern',
            selectX: {
                '0': 'Wählen Sie %{smart_count}',
                '1': 'Wählen Sie %{smart_count}',
                '2': 'Wählen Sie %{smart_count}'
            },
            smile: 'Bitte lächeln!',
            startRecording: 'Videoaufnahme starten',
            stopRecording: 'Videoaufnahme beenden',
            takePicture: 'Ein Foto machen',
            timedOut: 'Upload für %{seconds} Sekunden stehen geblieben, breche ab.',
            upload: 'Upload',
            uploadComplete: 'Upload beendet',
            uploadFailed: 'Upload fehlgeschlagen',
            uploadPaused: 'Upload pausiert',
            uploadXFiles: {
                '0': '%{smart_count} Datei hochladen',
                '1': '%{smart_count} Dateien hochladen',
                '2': '%{smart_count} Dateien hochladen'
            },
            uploadXNewFiles: {
                '0': '+%{smart_count} Datei hochladen',
                '1': '+%{smart_count} Dateien hochladen',
                '2': '+%{smart_count} Dateien hochladen'
            },
            uploadingXFiles: {
                '0': '%{smart_count} Datei wird hochgeladen',
                '1': '%{smart_count} Dateien werden hochgeladen',
                '2': '%{smart_count} Dateien werden hochgeladen'
            },
            xFilesSelected: {
                '0': '%{smart_count} Datei ausgewählt',
                '1': '%{smart_count} Dateien ausgewählt',
                '2': '%{smart_count} Dateien ausgewählt'
            },
            xMoreFilesAdded: {
                '0': '%{smart_count} weitere Datei hinzugefügt',
                '1': '%{smart_count} weitere Dateien hinzugefügt',
                '2': '%{smart_count} weitere Dateien hinzugefügt'
            },
            xTimeLeft: '%{time} verbleibend',
            youCanOnlyUploadFileTypes: 'Sie können nur folgende Dateitypen hochladen: %{types}',
            youCanOnlyUploadX: {
                '0': 'Sie können nur %{smart_count} Datei hochladen',
                '1': 'Sie können nur %{smart_count} Dateien hochladen',
                '2': 'Sie können nur %{smart_count} Dateien hochladen'
            },
            youHaveToAtLeastSelectX: {
                '0': 'Sie müssen mindestens %{smart_count} Datei auswählen',
                '1': 'Sie müssen mindestens %{smart_count} Dateien auswählen',
                '2': 'Sie müssen mindestens %{smart_count} Dateien auswählen'
            },
            selectAllFilesFromFolderNamed: 'Wählen Sie alle Dateien aus dem Ordner %{name}',
            unselectAllFilesFromFolderNamed: 'Heben Sie die Auswahl aller Dateien aus dem Ordner auf %{name}',
            selectFileNamed: 'Datei aussuchen %{name}',
            unselectFileNamed: 'Datei abwählen %{name}',
            openFolderNamed: 'Ordner öffnen %{name}'
        }
    };
}

export function getUppyFrenchLocale() {
    return {
        strings: {



            dropPasteFiles: 'Add files or %{browseFiles}',
            dropPasteFolders: '%{browseFiles}',
            dropPasteBoth: '%{browseFiles}%{browseFolders}',  // Drop files here,
            dropPasteImportFiles: 'ttttAdd files, %{browseFiles}:',
            dropPasteImportFolders: 'OOAdd files here or %{browseFolders} or upload from:',
            dropPasteImportBoth: '%{browseFiles} %{browseFolders}',
            dropHint: 'Déposez vos dossiers ici',
            browseFiles: 'Ajouter des fichiers',
            uploading: 'Encrypting and uploading',
            browseFolders: 'ou sélectionner un répertoire',

            addBulkFilesFailed: {
                '0': 'L\'ajout de %{smart_count} fichier a échoué',
                '1': 'L\'ajout de %{smart_count} fichiers a échoué'
            },
            addMore: 'Ajouter d\'autres',
            addMoreFiles: 'Ajouter d\'autres fichiers',
            addingMoreFiles: 'En train d\'ajouter des fichiers',
            allowAccessDescription: 'Pour prendre des photos ou enregistrer une vidéo avec votre caméra, veuillez autoriser l\'accès à votre caméra pour ce site.',
            allowAccessTitle: 'Veuillez autoriser l\'accès à votre caméra',
            authenticateWith: 'Se connecter à %{pluginName}',
            authenticateWithTitle: 'Veuillez vous authentifier avec %{pluginName} pour sélectionner les fichiers',
            back: 'Retour',
            browse: 'naviguer',
            // browseFiles: 'naviguer',
            cancel: 'Annuler',
            cancelUpload: 'Annuler téléchargement',
            chooseFiles: 'Choisir des fichiers',
            closeModal: 'Fermer Fenêtre',
            companionError: 'Connexion à Companion a échoué',
            companionUnauthorizeHint: 'Pour vous déconnecter de votre compte %{provider}, veuillez aller à %{url}',
            complete: 'Terminé',
            connectedToInternet: 'Connecté à Internet',
            copyLink: 'Copier lien',
            copyLinkToClipboardFallback: 'Copier le lien ci-dessous',
            copyLinkToClipboardSuccess: 'Lien copié',
            creatingAssembly: 'Préparation du téléchargement...',
            creatingAssemblyFailed: 'Transloadit: Impossible de créer Assembly',
            dashboardTitle: 'Téléchargeur de fichier',
            dashboardWindowTitle: 'Fenêtre de téléchargeur de fichier (Appuyez sur echap pour fermer)',
            dataUploadedOfTotal: '%{complete} sur %{total}',
            done: 'Terminé',

            // dropPasteBoth: '%{browseFiles} déposez des fichiers ici ',
            // dropPasteImportBoth: '%{browseFiles} %{browseFolders} or import from:',
            // dropHint: 'Déposez vos dossiers ici',

            editFile: 'Modifier fichier',
            editing: 'Modification en cours de %{file}',
            emptyFolderAdded: 'Aucun fichier n\'a été ajouté depuis un dossier vide',
            encoding: 'Traitement...',
            enterCorrectUrl: 'Lien incorrect: Assurez-vous que vous entrez un lien direct vers le fichier',
            enterUrlToImport: 'Entrez le lien pour importer un fichier',
            exceedsSize: 'Ce fichier dépasse la taille maximale autorisée de',
            failedToFetch: 'Companion a échoué à récupérer ce lien, assurez-vous qu\'il est correct',
            failedToUpload: 'Le téléchargement de %{file} a échoué',
            fileSource: 'Fichier source: %{name}',
            filesUploadedOfTotal: {
                '0': '%{complete} sur %{smart_count} fichier téléchargé',
                '1': '%{complete} sur %{smart_count} fichiers téléchargés',
                '2': '%{complete} sur %{smart_count} fichiers téléchargés'
            },
            filter: 'Filtrer',
            finishEditingFile: 'Terminer l\'édition du fichier',
            folderAdded: {
                '0': '%{smart_count} fichier ajouté de %{folder}',
                '1': '%{smart_count} fichiers ajoutés de %{folder}',
                '2': '%{smart_count} fichiers ajoutés de %{folder}'
            },
            generatingThumbnails: 'Generating thumbnails...',
            import: 'Importer',
            importFrom: 'Importer de %{name}',
            loading: 'Chargement...',
            logOut: 'Déconnexion',
            micDisabled: 'Accès au micro refusé par l\'utilisateur',
            myDevice: 'Mon Ordinateur',
            noDuplicates: 'Impossible d\'ajouter le fichier "%{fileName}", il existe déjà',
            noFilesFound: 'Vous n\'avez aucun fichier ou dossier ici',
            noInternetConnection: 'Pas de connexion à Internet',
            noNewAlreadyUploading: 'Impossible d\'ajouter de nouveaux fichiers: en cours de chargement ',
            openFolderNamed: 'Ouvrir %{name}',
            pause: 'Pause',
            pauseUpload: 'Mettre en pause le téléchargement',
            paused: 'En pause',
            poweredBy: 'Propulsé par',
            processingXFiles: {
                '0': 'Traitement de %{smart_count} fichier',
                '1': 'Traitement de %{smart_count} fichiers',
                '2': 'Traitement de %{smart_count} fichiers'
            },
            recording: 'Enregistrement',
            recordingLength: 'Durée d\'enregistrement %{recording_length}',
            recordingStoppedMaxSize: 'L\'enregistrement s\'est arrété car la taille du fichier dépasse la limite',
            removeFile: 'Effacer le fichier',
            resetFilter: 'Réinitialiser filtre',
            resume: 'Reprendre',
            resumeUpload: 'Reprendre le téléchargement',
            retry: 'Réessayer',
            retryUpload: 'Réessayer le téléchargement',
            saveChanges: 'Sauvegarder les modifications',
            selectAllFilesFromFolderNamed: 'Sélectionner tous les fichiers du dossier %{name}',
            selectFileNamed: 'Sélectionner le fichier %{name}',
            selectX: {
                '0': 'Sélectionner %{smart_count}',
                '1': 'Sélectionner %{smart_count}',
                '2': 'Sélectionner %{smart_count}'
            },
            smile: 'Souriez !',
            startRecording: 'Commencer l\'enregistrement vidéo',
            stopRecording: 'Arrêter l\'enregistrement vidéo',
            streamActive: 'Stream actif',
            streamPassive: 'Stream passif',
            submitRecordedFile: 'Envoyer la vidéo enregistrée',
            takePicture: 'Prendre une photo',
            timedOut: 'Téléchargement bloqué durant %{seconds} secondes, annulation.',
            unselectAllFilesFromFolderNamed: 'Désélectionner tous les fichiers du dossier %{name}',
            unselectFileNamed: 'Désélectionner le fichier %{name}',
            upload: 'Télécharger',
            uploadComplete: 'Téléchargement terminé',
            uploadFailed: 'Le téléchargement a échoué',
            uploadPaused: 'Téléchargement mis en pause',
            uploadXFiles: {
                '0': 'Télécharger %{smart_count} fichier',
                '1': 'Télécharger %{smart_count} fichiers',
                '2': 'Télécharger %{smart_count} fichiers'
            },
            uploadXNewFiles: {
                '0': 'Télécharger +%{smart_count} fichier',
                '1': 'Télécharger +%{smart_count} fichiers',
                '2': 'Télécharger +%{smart_count} fichiers'
            },
            // uploading: 'Encrypting and uploading',
            uploadingXFiles: {
                '0': 'Téléchargement de %{smart_count} fichier',
                '1': 'Téléchargement de %{smart_count} fichiers',
                '2': 'Téléchargement de %{smart_count} fichiers'
            },
            xFilesSelected: {
                '0': '%{smart_count} fichier sélectionné',
                '1': '%{smart_count} fichiers sélectionnés',
                '2': '%{smart_count} fichiers sélectionnés'
            },
            xMoreFilesAdded: {
                '0': '%{smart_count} autre fichier ajouté',
                '1': '%{smart_count} autres fichiers ajoutés',
                '2': '%{smart_count} autres fichiers ajoutés'
            },
            xTimeLeft: '%{time} restantes',
            youCanOnlyUploadFileTypes: 'Vous pouvez seulement télécharger: %{types}',
            youCanOnlyUploadX: {
                '0': 'Vous pouvez seulement télécharger %{smart_count} fichier',
                '1': 'Vous pouvez seulement télécharger %{smart_count} fichiers',
                '2': 'Vous pouvez seulement télécharger %{smart_count} fichiers'
            },
            youHaveToAtLeastSelectX: {
                '0': 'Vous devez sélectionner au moins %{smart_count} fichier',
                '1': 'Vous devez sélectionner au moins %{smart_count} fichiers',
                '2': 'Vous devez sélectionner au moins %{smart_count} fichiers'
            }
        }
    };
}


/**
 * Uses the title attribute of an input as well as the :valid selectors to show errors
 */
export function showHideFormErrors(elem: HTMLInputElement) {
    const parentElement = elem.parentElement;
    if(!parentElement) {
        return
    }
    if (!elem.value || elem.validity.valid) {
        const spans = parentElement.getElementsByClassName("helper-text")
        if(spans.length > 0) {
            spans[0].remove()
        }
    } else {
        let span = parentElement.getElementsByClassName("helper-text")
        if (span.length === 0) {
            let s = document.createElement('div')
            s.classList.add('helper-text')
            s.classList.add('w-100')
            s.innerText = elem.title
            parentElement.appendChild(s)
        }
    }
}


/**
 * Sets up the IndexedDb for key storage
 */
export function getIndexedDB(onsuccess: (event: Event) => void, onerror: (event: Event) => void) {
    let db;
    let dbReq = indexedDB.open('arcano.app', 1);
    dbReq.onupgradeneeded = (event) => {
        // Set the db variable to our database, so we can use it!
        // @ts-ignore
        db = event.target.result;
        // Create an object store
        db.createObjectStore('key', {autoIncrement: true});
    }
    dbReq.onsuccess = onsuccess;
    dbReq.onerror = onerror;
}



function setupMonthAnnualSwitch() {
    let monthSwitch = document.getElementById('monthly-alternator')!;
    let annualSwitch = document.getElementById('annually-alternator')!;
    let monthlyPrices = document.getElementsByClassName('monthly-price');
    let annuallyPrices = document.getElementsByClassName('annually-price');

    let buyNowButton = document.getElementById('buy-now-button') as HTMLAnchorElement;

    if(monthSwitch && annualSwitch && monthlyPrices && annuallyPrices) {
        monthSwitch.addEventListener('click', (event) => {
            // switching from annual (visible by default) to monthly
            event.preventDefault();
            // alternate between monthly and annually pricing display
            monthSwitch.className = "btn btn-sm btn-outline-primary active";
            annualSwitch.className = "btn btn-sm btn-outline-primary";
            for (let i = 0; i < monthlyPrices.length; i++) {
                monthlyPrices[i].className = "monthly-price";
            }
            for (let i = 0; i < annuallyPrices.length; i++) {
                annuallyPrices[i].className = "annually-price hidden";
            }
            if(buyNowButton) {
                const url = new URL(buyNowButton.href)
                url.searchParams.set('buy', 'month')
                buyNowButton.href = url.toString()
            }
        });
        annualSwitch.addEventListener('click', (event) => {
            // switching from annual (visible by default) to monthly
            event.preventDefault();
            // alternate between monthly and annually pricing display
            monthSwitch.className = "btn btn-sm btn-outline-primary";
            annualSwitch.className = "btn btn-sm btn-outline-primary active";
            for (let i = 0; i < monthlyPrices.length; i++) {
                monthlyPrices[i].className = "monthly-price hidden";
            }
            for (let i = 0; i < annuallyPrices.length; i++) {
                annuallyPrices[i].className = "annually-price";
            }
            if(buyNowButton) {
                const url = new URL(buyNowButton.href)
                url.searchParams.set('buy', 'year')
                buyNowButton.href = url.toString()
            }
        });
    }
}


export function readCookie(name: string): string {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return '';
}


export const createElemWithClasses = (tagName: string, classList: Array<string> = []) => {
    const div = document.createElement(tagName)
    classList.forEach(cls => {
        div.classList.add(cls)
    })
    return div
}
export const groupArrayOfObjects = (list: Array<any>, key: string) => {
    return list.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}
export const groupBy = (array: any, f: any) => {
    const tmpGroups: any = {}
    array.forEach((o: any) => {
        const groups = f(o)

        tmpGroups[groups] = tmpGroups[groups] || []
        tmpGroups[groups].push(o)
    })

    return tmpGroups
}

export function escapeHtml(s: string): string {
	let tmp = document.createElement('div');
	tmp.innerHTML = s;
	return tmp.textContent || tmp.innerText || '';
}
